/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import styles from './styles';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import SelectEditInputTextField from '../../SelectEditInputTextField';
import Datagrid from '../../Datagrid';
import columns from './table_config';
import PropTypes from 'prop-types';
import useUnitConversion from '../../../../hooks/useUnitConversion';

const CuttingPropertyModal = ({
  data,
  setUpdateCuttingData,
  invalidCuttingRows,
  setParameterDirty,
  proxyLoader
}) => {
  const classes = styles();
  const apiRef = useGridApiRef();
  const hydraulics = useSelector((state) => state.hydraulics);
  const stripping = useSelector((state) => state.stripping);
  const hydraulicsParameter = useSelector((state) => state.hydraulicsParameterAnalysis);
  const hydraulicsDisplacement = useSelector((state) => state.displacement);
  const [properties, setProperties] = useState([]);
  const { unit } = useUnitConversion();
  const rollover = useSelector((state) => state.rollover);

  function generateRandom() {
    const length = 24;
    const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let retVal = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  useEffect(() => {
    setProperties([{ _id: generateRandom(), ...data }]);
  }, [hydraulics, data]);

  useEffect(() => {
    if (properties[0]?.diameter === '') {
      const id = properties[0]._id;
      setTimeout(() => {
        apiRef.current.scrollToIndexes({
          rowIndex: 0
        });
        apiRef.current.setCellMode(id, 'diameter', 'edit');
        setTimeout(() => {
          apiRef.current.setCellFocus(id, 'diameter');
        }, 50);
      }, 50);
      apiRef.current.setPage(0);
    }
  }, [properties?.length]);

  const updateData = (id, field, value) => {
    setProperties(prevProperties => {
      const updatedProperties = prevProperties.map(item => {
        if (item._id === id) {
          const isDirty = value !== item[field];
          return {
            ...item,
            [field]: Number(value),
            isDirty
          };
        }
        return item;
      });
      return updatedProperties;
    });
    setUpdateCuttingData(prev => ({
      ...prev,
      [field]: value,
      _id: id
    }));
    setParameterDirty(prev => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      const updated = [...prev];
      updated[0] = { ...updated[0], isDirty: true };
      return updated;
    });
  };

  const renderValueCell = (params) => {
    return <SelectEditInputTextField numberFormatOnly {...params} updateData={updateData} />;
  };

  return (
    <>
      <Grid container maxWidth='1000px'>
        <Grid item xs={12}>
          <Datagrid
            apiRef={apiRef}
            data={properties}
            sx={{
              marginLeft: '-6px',
              '.MuiDataGrid-cell': {
                fontSize: '1rem',
                fontWeight: 900,
                pointerEvents: proxyLoader ? 'none' : 'auto',
                backgroundColor: proxyLoader ? '#f5f5f5' : 'inherit'
              },
              '.MuiDataGrid-columnHeader': {
                fontSize: '1.2rem',
                fontWeight: '900 !important'
              },
              '& .MuiDataGrid-footerContainer': {
                display: 'none',
              },
            }}
            loading={hydraulics?.details?.loading || rollover?.loading || stripping?.loading || hydraulicsParameter?.loading || hydraulicsDisplacement?.loading}
            columns={columns(renderValueCell, hydraulics?.details?.units?.inputs?.cuttings_data, unit)}
            onRowClick={(params, evt) => {
              evt.preventDefault();
              evt.stopPropagation();
            }}
            disableStickyHeader={false}
            autoHeight={false}
            autoheight
            height={'150px'}
            getRowClassName={(params) => {
              return proxyLoader ? 'Mui-disabled' : (invalidCuttingRows[params.id] ? classes.invalidRow : '');
            }}
            pageSize={100}
            editMode="cell"
            toolbar={{
              options: {
                columns: false,
                filters: false,
                density: false,
                export: false
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};
CuttingPropertyModal.propTypes = {
  data: PropTypes.any,
  setUpdateCuttingData: PropTypes.any,
  invalidCuttingRows: PropTypes.any,
  setParameterDirty: PropTypes.func,
  proxyLoader: PropTypes.bool
};

export default CuttingPropertyModal;
